import { useEffect, useState } from "react";

import get from "lodash/get";

import { useApplicationContext } from "contexts/app";

const useOptions = (url?: string | false | undefined, path?: string, errorHandler?: () => void) => {
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const { httpClient } = useApplicationContext();

  useEffect(() => {
    if (url) {
      setLoading(true);

      httpClient
        .options(url, {
          errorHandler,
        })
        .then((res: any) => {
          if (path) {
            const val = get(res, path);
            if (val) setResult(val);
          } else {
            setResult(res);
          }

          setLoading(false);
        });
    }

    return () => {
      setResult(null);
    };
  }, [url, path]);

  return { result, loading };
};

export default useOptions;
